import { el } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

class ProducerModeEndedView {

  constructor(labelTextPrefix = 'Streaming is already ended', post) {

    this.timerReference = null;
    this.displayLifeTimeInSeconds = 5;
    this.labelTextPrefix = labelTextPrefix;
    this.post = post;

    this.endedViewLabel = el('label.ended-view-label', this.getLabelText());

    this.endedViewPostLinkControl = el('button.ended-view-post-link-control', 'Go to post');
    this.endedViewPostLinkControl.addEventListener('click', this.handleEndedViewPostLinkClick.bind(this));

    this.el = el('.producer-mode-ended-view-main', [el('.ended-view-label-container', this.endedViewLabel), this.endedViewPostLinkControl]);

  }

  onmount() {

    this.tryLoopRedirectionCountDown();

  }

  onunmount() {

    clearTimeout(this.timerReference);

  }

  gotoPost() {

    application.eventSystem.internal.emit(internalEventCodes.NAVIGATE_TO, {
      to: `/community/${this.post.humanFriendlyId}`
    });

  }

  handleEndedViewPostLinkClick() {
    this.gotoPost();
  }

  getLabelText() {

    return `${this.labelTextPrefix}. Click below link or you will be automatically redirected in ${this.displayLifeTimeInSeconds} seconds.`;

  }

  updateLabelText() {

    this.endedViewLabel.textContent = this.getLabelText();

  }

  tryLoopRedirectionCountDown() {

    if (this.displayLifeTimeInSeconds === 0) {

      this.gotoPost();

      return;

    }

    this.displayLifeTimeInSeconds--;

    setTimeout(function oneSecondLater() {

      this.updateLabelText();
      this.tryLoopRedirectionCountDown();

    }.bind(this), 1000);

  }

}

export default ProducerModeEndedView;